import interpolateComponents from '@automattic/interpolate-components';
import { sprintf } from 'sprintf-js';

import { ApiInvite } from 'api/invite/types/ApiInvite';

type Props = {
  invite: ApiInvite;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hook: Record<string, any>;
};

export function InviteMessage({ invite, hook }: Props) {
  switch (hook.hookType) {
    case 'PROMOTE_TO_ADMIN':
      return (
        <div>
          {interpolateComponents({
            mixedString: sprintf(
              getText(
                '%(inviter)s has invited you to become an administrator of ' +
                  '{{strong}}%(name)s{{/strong}}.',
              ),
              {
                inviter: invite.byUser.name,
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                name: hook.organization && hook.organization.name,
              },
            ),
            components: {
              strong: <strong />,
            },
          })}
        </div>
      );

    case 'PROMOTE_TO_OWNER':
      return (
        <div>
          {interpolateComponents({
            mixedString: sprintf(
              getText(
                '%(inviter)s has invited you to become an owner of ' +
                  '{{strong}}%(name)s{{/strong}}.',
              ),
              {
                inviter: invite.byUser.name,
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                name: hook.organization && hook.organization.name,
              },
            ),
            components: {
              strong: <strong />,
            },
          })}
        </div>
      );

    default:
      throw new Error('invalid hook type');
  }
}
